import { useSnapshot } from 'valtio';
import { authStore } from '../../store/authStore';
import { roleStore, Role } from '../../store/roleStore';
import { useGetUnreadCountsQuery } from '../services/notificationService/__generated__/queries.generated';

/** Unread system notification count for navbar badge (role-scoped, cache-first). */
export function useUnreadNotificationCount(): number {
  const auth = useSnapshot(authStore);
  const { role } = useSnapshot(roleStore);
  const userId = auth.user?.id;
  const isAuthenticated = auth.isAuthenticated && !!userId;
  const countRole = role === Role.ADMIN ? Role.GUEST : role;

  const { data } = useGetUnreadCountsQuery({
    variables: { role: countRole as string },
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
  });

  return data?.getUnreadCounts?.notificationsCount ?? 0;
}
